import {
  CartItemsHeader,
  CartItemsProducts,
} from "@/components/cells"
import { HttpTypes } from "@medusajs/types"
import { EmptyCart } from "./EmptyCart"
import { useCartFit } from "@/components/molecules/CartFitWarning/CartFitWarning"

export const CartItems = ({ cart }: { cart: HttpTypes.StoreCart | null }) => {
  const fit = useCartFit(cart?.items)
  if (!cart) return null

  const groupedItems: any = groupItemsBySeller(cart)

  if (!Object.keys(groupedItems).length) return <EmptyCart />

  return Object.keys(groupedItems).map((key) => (
    <div key={key} className="mb-4" data-testid={`cart-items-seller-${key}`}>
      <CartItemsHeader seller={groupedItems[key]?.seller} />
      <CartItemsProducts
        products={groupedItems[key].items || []}
        currency_code={cart.currency_code}
        fit={fit}
      />
      {/* لا سطر توصيل لكل بائع: التوصيل يُختار عند إتمام الطلب، و«شحنة مجمّعة» برسم واحد
          للبائعين كلهم. وكان السطر يعرض مجموع توصيل السلة كلها تحت كل بائع. */}
    </div>
  ))
}

function groupItemsBySeller(cart: HttpTypes.StoreCart) {
  const groupedBySeller: any = {}

  cart.items?.forEach((item: any) => {
    const seller = item.offer?.seller
    if (seller) {
      if (!groupedBySeller[seller.id]) {
        groupedBySeller[seller.id] = {
          seller: { ...seller, photo: seller.photo ?? seller.logo },
          items: [],
        }
      }
      groupedBySeller[seller.id].items.push(item)
    } else {
      if (!groupedBySeller["fleek"]) {
        groupedBySeller["fleek"] = {
          seller: {
            name: "السوق الليبي لقطع الغيار",
            id: "fleek",
            photo: "/images/placeholder.svg",
            created_at: new Date(),
          },
          items: [],
        }
      }
      groupedBySeller["fleek"].items.push(item)
    }
  })

  return groupedBySeller
}
